import { useEffect, useRef } from 'react';
import useAuth from './useAuth';
import WebSocketManager from '../util/notificationSocketManager';
import { useDispatch } from 'react-redux';

/**
 *
 * @returns {{ wsManager: React.MutableRefObject<WebSocketManager|null> }}
 */
const useWs = () => {
    /** @type {React.MutableRefObject<WebSocketManager|null>} */
    const wsRef = useRef(null);
    const auth = useAuth();
    const { isAuthenticated, user } = auth;
    const dispatch = useDispatch();

    useEffect(() => {
        if (isAuthenticated && user && user.user_id) {
            wsRef.current = new WebSocketManager(dispatch, user.user_id);
        }

        if (!isAuthenticated && wsRef.current) {
            wsRef.current.closeConnection(true);
            wsRef.current = null;
        }
    }, [isAuthenticated, dispatch, user?.user_id]);

    return {
        wsManager: wsRef.current,
    };
};

export default useWs;
